import pax8Logo from "assets/images/cancel-subscription/pax8Logo.png";
import xeroLogo from "assets/images/cancel-subscription/xeroLogo.webp";
import splashtopLogo from "assets/images/cancel-subscription/splashTopLogo.webp";
import stripeLogo from "assets/images/cancel-subscription/stripeLogo.webp";
import itglueLogo from "assets/images/cancel-subscription/itGlueLogo.webp";
import dattoLogo from "assets/images/cancel-subscription/dattoLogo.webp";
import connectWiseScreenConnectLogo from "assets/images/cancel-subscription/screenConnectLogo.webp";
import acronisLogo from "assets/images/cancel-subscription/acronisLogo.webp";

export const desiredIntegrationsList = [
  {
    label: "Pax8",
    value: "pax8",
    logo: pax8Logo,
  },
  {
    label: "Stripe",
    value: "stripe",
    logo: stripeLogo,
  },
  // {
  //   label: "Xero",
  //   value: "xero",
  //   logo: xeroLogo,
  // },
  // {
  //   label: "Datto",
  //   value: "datto",
  //   logo: dattoLogo,
  // },
  {
    label: "ConnectWise ScreenConnect",
    value: "connectwise-screenconnect",
    logo: connectWiseScreenConnectLogo,
  },
  {
    label: "Splashtop",
    value: "splashtop",
    logo: splashtopLogo,
  },
  {
    label: "IT-Glue",
    value: "it-glue",
    logo: itglueLogo,
  },
  {
    label: "Acronis",
    value: "acronis",
    logo: acronisLogo,
  },
];

export const desiredFeaturesList = [
  {
    label: "CC & escalations",
    value: "cc-escalations",
  },
  {
    label: "Sales module (leads, quotes)",
    value: "sales-module",
  },
  { label: "Asset management", value: "asset-management" },
  { label: "Procurement & inventory", value: "procurement-inventory" },
  {
    label: "Advanced reports & analytics",
    value: "advanced-reports-analytics",
  },
  {
    label: "Resource scheduling & calendar integration",
    value: "resource-scheduling-calendar-integration",
  },
];

export const reasonsForStopUsingList = [
  {
    label: "Switched to another tool",
    value: "switched-to-another-tool",
  },
  {
    label: "Business closed or downsized",
    value: "business-closed-or-downsized",
  },
  {
    label: "Temporary pause in operations",
    value: "temporary-pause-in-operations",
  },
  {
    label: "No longer needed for our workflow",
    value: "no-longer-needed-for-our-workflow",
  },
];
